
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/khata-management-software",
      function () {
        return require("private-next-pages/features/khata-management-software.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/khata-management-software"])
      });
    }
  